import React from 'react';
import { motion } from "framer-motion";
import { withRouter } from 'react-router-dom'
import { ShareThatPhotoGameData } from './../../data/GameData';
import Touchpoint from './Touchpoint';
import TouchpointFinish from './TouchpointFinish';
import Summary from './Summary';

// export const contentTransitionOptions  = { type: 'spring', stiffness: 200, damping: 20, };
export const contentTransitionOptions  = { ease: 'backInOut', duration: 3, };

/*
export const contentTransition  = {
  start: { x: '0%', transition: contentTransitionOptions },
  section1: { x: '-16.666666667%', transition: contentTransitionOptions },
  section2: { x: '-33.333333334%', transition: contentTransitionOptions },
  section3: { x: '-50%', transition: contentTransitionOptions },
  section4: { x: '-66.666666667%', transition: contentTransitionOptions },
  section5: { x: '-83.333333335%', transition: contentTransitionOptions },
}
*/

export const contentTransition  = {
  start: { x: '0%', transition: contentTransitionOptions },
  section1: { x: '-20%', transition: contentTransitionOptions },
  section2: { x: '-40%', transition: contentTransitionOptions },
  section3: { x: '-60%', transition: contentTransitionOptions },
  section4: { x: '-80%', transition: contentTransitionOptions },
}

class PhotoJourney extends React.Component {
  
  constructor(props) {
    super(props)
    
    var self = this,
        people = ShareThatPhotoGameData.people,
        shareChain = ShareThatPhotoGameData.shareChain,
        params = new URLSearchParams(this.props.location.search),
        peopleData = (params.get('people')) ? params.get('people').split(',') : [];
    
    peopleData.forEach(personId => {
      
      const person = people.find((item) => {
          return item.id === parseInt(personId);
      });
      
      if(person) {
        shareChain.push(person);
      }
      
    })
    
    
    this.state = {
      sectionCount: 5,
      currentSection: (shareChain.length > 0) ? 4 : 0,
      startSection: (shareChain.length > 0) ? 'section4' : 'start',
      people: people,
      shareChain: shareChain,
      printing: false
    };
    
    this.goToNextSection = this.goToNextSection.bind(this);
//     this.didChooseFinish = this.didChooseFinish.bind(this);
  }
  
  didSelectPerson = (person) => {
    var self = this;
    
    self.state.shareChain.push(person);
    //self.goToNextSection();
    self.forceUpdate();
    
    setTimeout(function() {
      self.goToNextSection();
    }, 1500);
    
  }
  
  didChoosePromptOption = () => {
    var self = this;
    self.goToNextSection();
  }
  
  didSelectPrint = () => {
    // @todo print screen...
    //prompt("Permalink", this.permalink());
    this.setState({printing:true});
    fetch('https://o18jzj3fw8.execute-api.ap-southeast-2.amazonaws.com/Prod/snap', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        path: this.permalink(),//'http://games.playingitsafe.org.au/share-that-photo?people=3%2C5%2C7%2C8',
        pdf: true,
        landscape: true,
        scale: "0.8"
      }),
    }).then((response) => response.json())
    .then((responseJson) => {
      this.setState({printing:false});
      console.log(responseJson);
      if(responseJson.url){
        //window.location.href = responseJson.url;
        const win = window.open(responseJson.url, '_blank');
        if (win != null) {
          win.focus();
        }
      }
    })
    .catch((error) => {
      this.setState({printing:false});
      console.error(error);
    });;
  }
  
  encodeQueryData(data) {
     const ret = [];
     for (let d in data)
       ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
     return ret.join('&');
  }
  
  permalink() {
    var data = [];
    
    console.log('share chain', this.state.shareChain);
        
    this.state.shareChain.forEach(person => {
      data.push(person.id);
    })
    
    console.log('data', data);
    
    return document.location.href+'?'+this.encodeQueryData({'people':data.join(',')});
  }
  
  goToNextSection() {
    var nextSection = this.state.currentSection+1;
    
    if(nextSection >= this.state.sectionCount) {
      return;
    }
    
    this.setState({
        currentSection: nextSection,
    });
    
  }
  
  componentDidMount() {
    
  }
  
  render() {
    
    const { currentSection, startSection, people, shareChain, printing } = this.state;
    
    var self = this;
    
    return (
      
      <div className="photo-journey">
        <div className="photo-journey__viewport">

          <motion.div className="photo-journey__content" 
            initial={startSection}
            animate={(currentSection > 0) ? 'section'+currentSection : 'start'}
            variants={contentTransition}
            custom={currentSection}
          >
            
            <Touchpoint 
                onSelectPerson={self.didSelectPerson} 
                people={people} 
                device="selfie-phone" 
                shareChain={[]}
                isActive={currentSection === 0}
                wasActive={currentSection > 0} />
            
            <Touchpoint 
                onSelectPerson={self.didSelectPerson} 
                people={people} 
                isActive={currentSection === 1} 
                wasActive={currentSection > 1}
                toPerson={(shareChain.length > 0) ? shareChain[0] : null}
                fromPerson={null}
                shareChain={shareChain} />
            
            <Touchpoint 
                onSelectPerson={self.didSelectPerson} 
                people={people} 
                shareChain={shareChain}
                isActive={currentSection === 2} 
                toPerson={(shareChain.length > 1) ? shareChain[1] : null}
                fromPerson={(shareChain.length > 1) ? shareChain[0] : null}
                wasActive={currentSection > 2} />
            
            <Touchpoint 
                onSelectPerson={self.didSelectPerson} 
                people={people} 
                shareChain={shareChain}
                isActive={currentSection === 3} 
                toPerson={(shareChain.length > 2) ? shareChain[2] : null}
                fromPerson={(shareChain.length > 2) ? shareChain[1] : null}
                wasActive={currentSection > 3} />            
            
            
            {/*
            <TouchpointFinish 
                onSelectNext={self.didChoosePromptOption} 
                onSelectYes={self.didChoosePromptOption} 
                onSelectNo={self.didChoosePromptOption} 
                people={people} 
                toPerson={(shareChain.length > 3) ? shareChain[3] : null}
                fromPerson={(shareChain.length > 3) ? shareChain[2] : null}
                shareChain={shareChain}
                isActive={currentSection === 4} />
            */}
                
            <Summary 
                people={people} 
                shareChain={shareChain}
                onSelectFinish={self.props.onFinish} 
                onPrint={self.didSelectPrint}
                isActive={currentSection === 5}
                printingStatus={printing} />
            
          </motion.div>
          
        </div>
      </div>
      
    )
  }
};


export default withRouter(PhotoJourney);